<template>
  <b-dropdown expanded ref="dropdown">
    <template #trigger>
      <TriggerButton>
        <template v-if="!isActive">
          {{ label }}
        </template>
        <template v-else>
          {{ label }}: <span>{{ range }}</span>
        </template>
      </TriggerButton>
    </template>
    <b-field>
      <b-slider
        v-model="numbers"
        :min="min"
        :max="max"
        :step="1"
        tooltip-always
        :custom-formatter="(val) => val.toString()"
      >
      </b-slider>
    </b-field>
    <b-dropdown-item separator />
    <b-dropdown-item custom :focusable="false">
      <b-field grouped>
        <ResetButton @click="reset" expanded class="is-margin-right" />
        <b-button @click="submit" expanded>
          {{ $t("Apply") }}
        </b-button>
      </b-field>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import TriggerButton from "./TriggerButton.vue";
import ResetButton from "./ResetButton.vue";

import omit from "lodash/omit";

export default {
  components: {
    TriggerButton,
    ResetButton,
  },
  props: {
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  watch: {
    "$route.query": {
      handler(query) {
        // TODO: clean this up
        this.numbers = [this.min, this.max];
        if (query[this.name] instanceof Array) {
          [this.from, this.to] = this.validate(query[this.name]);
          this.numbers = [this.from, this.to];
          // TODO: check for validity first to avoid unnecessary computation
          this.$router.push({
            query: {
              ...this.$route.query,
              [this.name]: [this.from, this.to],
            },
          });
        }
      },
      immediate: true,
    },
    numbers(value) {
      this.from = value[0];
      this.to = value[1];
    },
  },
  data() {
    return {
      from: this.min,
      to: this.max,
      numbers: [this.from, this.to],
    };
  },
  computed: {
    isActive() {
      const range = this.$route.query[this.name];
      return range instanceof Array && range.length === 2;
    },
    range() {
      const [from, to] = this.$route.query[this.name];
      return `${from} - ${to}`;
    },
    slideRange: {
      get() {
        return [this.from, this.to];
      },
      set(value) {
        const [from, to] = value;
        this.from = from;
        this.to = to;
      },
    },
  },
  methods: {
    validate([from, to]) {
      from = parseInt(from);
      to = parseInt(to);

      if (!Number.isInteger(from)) from = this.min;

      if (!Number.isInteger(to)) to = this.max;

      from = Math.max(this.min, Math.min(from, this.max));
      to = Math.max(this.min, Math.min(to, this.max));

      if (this.to < this.from) {
        const value = this.from;
        this.from = this.to;
        this.to = value;
      }

      return [from, to];
    },
    sanitize() {
      if (!Number.isInteger(parseInt(this.from))) {
        this.from = this.min;
      }

      if (!Number.isInteger(parseInt(this.to))) {
        this.to = this.max;
      }

      this.from = Math.max(this.min, Math.min(this.from, this.max));
      this.to = Math.max(this.min, Math.min(this.to, this.max));

      if (this.to < this.from) {
        const value = this.from;
        this.from = this.to;
        this.to = value;
      }
    },
    submit() {
      [this.from, this.to] = this.validate([this.from, this.to]);

      this.$router.push({
        query: {
          ...this.$route.query,
          [this.name]: [this.from, this.to],
        },
      });

      this.toggle();
    },
    check(event) {
      this.$refs.from.checkHtml5Validity();
      this.$refs.to.checkHtml5Validity();
    },
    toggle() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.toggle();
      }
    },
    reset() {
      this.from = this.min;
      this.to = this.max;
      this.$router.push({ query: omit(this.$route.query, this.name) });
      this.toggle();
    },
  },
};
</script>
